import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class ChatService extends BaseService {

    static url = "chats";
    loader = false;
    static apis = {
        that: this,
        getSpecific: {
            path: function(customerId, kitId) {
                return "chats/" + customerId + "/" + kitId
            },
            method: "GET"
        },
        getChatMessages: {
            path: function(chatId) {
                return "chats/" + chatId + "/messages"
            }
        },

        getChatById: {
            path: function(id) {
                return "chats/" + id 
            }
        }
    }

    constructor(repo, loader = false) {
        super(repo);
        this.repo = new ApiHelper("customers");
        this.loader = loader
    }

    getChatMessages(chatId) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: ChatService.apis.getChatMessages.path(chatId), method: "GET", authorization: true, showLoader: this.loader })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getChatById(chatId) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: ChatService.apis.getChatById.path(chatId), method: "GET", authorization: true, showLoader: this.loader })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getSpecific(customerId, kitId) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: ChatService.apis.getSpecific.path(customerId, kitId), method: ChatService.apis.getSpecific.method, authorization: true, showLoader: this.loader })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default ChatService;